// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"9d891d73","326":"5f499876"}[chunkId] + ".js";
};